<div class="exception-body access">
    <img src="assets/layout/images/logo-white.svg" alt="SmartBox" class="logo">

    <div class="exception-content">
        <div class="exception-title">ACCESS DENIED</div>
        <div class="exception-detail">You do not have the necessary permissions.</div>
        <a [routerLink]="['/']">Go to Dashboard</a>
    </div>
</div>
